<template>
    <b-overlay :show="showoverlay" rounded="sm">            
          <b-form @submit.stop.prevent="onSubmit">
             
              <div class="clearfix company-form-container rounded pb-5 mx-auto pl-3 pr-3">
                  <div class="clearfix row py-2 mb-2 border-bottom"><div class="col-sm-12 px-3 company-form-box-title text_color ml-2">Gratuity Fund Migrated Contribution</div></div>
   
                  <div class="rounded border m-4 p-4">
                      <div class="row clearfix">
  
                          <div class="col-md-6">
                              <b-form-group id="migrated_fund_date-group" label="Migrated Fund Contribution Date" label-for="migrated_fund_date" class="required-field">
                                    <b-input-group class="mb-3">
                                        <b-form-input id="migrated_fund_date" :state="validateState('migrated_fund_date')" name="migrated_fund_date" v-model="fdata.migrated_fund_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{required:true,date_format:'yyyy-MM-dd' }"  aria-describedby="settlement_date-feedback" data-vv-as="Date"></b-form-input>
                                        <b-input-group-append>
                                                <b-form-datepicker id="migrated_fund_date" button-only right locale="en-US" v-model="fdata.migrated_fund_date"></b-form-datepicker>
                                        </b-input-group-append>
                                        <b-form-invalid-feedback id="migrated_fund_date-feedback">{{ veeErrors.first('migrated_fund_date') }}</b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                          </div>
                          <div class="col-md-6">
                                <b-form-group id="migrated_fund_amount-group" label="Total Migrated Contributions" class="required-field" label-for="migrated_fund_amount">    
                                    <b-form-input id="migrated_fund_amount" name="migrated_fund_amount" v-model="fdata.migrated_fund_amount" v-validate="{ required: true, regex: /^[0-9]*\.?[0-9]{0,2}$/ }" :state="validateState('migrated_fund_amount')" aria-describedby="migrated_fund_amount-feedback" data-vv-as="Total Migrated Contribution"></b-form-input>
                                    <b-form-invalid-feedback id="migrated_fund_amount-feedback">{{ veeErrors.first('migrated_fund_amount') }}</b-form-invalid-feedback>                            
                                </b-form-group>
                          </div>
                      </div>                        
                                                                          
                  <div class="col-md-12 float-right">
                      <div class="col-md-12 text-center mt-5">
                          <b-button type="submit" class="btn-primary" variant="success"> Save </b-button>                                    
                      </div>
                  </div>
              </div>
  
          </div>
  
          </b-form>
      </b-overlay>
  </template>
  
<script>
    export default {
        mounted() { },

        data() {
            return {
                showoverlay: false,                              
                disableme:true,
                fdata: { 
                    migrated_fund_date: null, 
                    migrated_fund_amount: 0
                    
                },              
                url : this.$api_url+'/gf/migrated-fund/save',
                get_url : this.$api_url+'/gf/migrated-fund',
            } 
        },
        
        methods: {
                        
            resetForm()
            { 
                this.fdata = { 
                    migrated_fund_date: null, 
                    migrated_fund_amount: 0
                };
            },
            onSubmit(e) { 
                if(!this.checkNet()) return false;                
                
                this.$validator.validateAll().then(result => {
                if (!result) {
                    return; 
                }
                this.showoverlay = true;      
                let currentObj = this;
                axios.post(this.url,this.fdata )
                    .then(function (response) 
                    {
                    
                    this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                    this.showoverlay = false;
                        
                    }.bind(this))
                    .catch(function (error) 
                    {                          
                    this.showoverlay = false;                        
                    currentObj.serverError(error);
                    });

                });
            },                                          
            get_migrated_fund(e) { 
                
                this.showoverlay = true;      
                // if(!this.checkNet()) return false;                
                // this.$validator.validateAll().then(result => {
                    //     if (!result) {
                        //         return;
                        //     }
                        
                        
                        // });
                let formData = new FormData();
                let currentObj = this;
                axios.post(this.get_url,formData )
                    .then(function (response) 
                    { 
                    if (response && response.data && Object.keys(response.data).length > 0)
                    {
                        this.fdata = response.data;
                    } 
                    else {
                        this.resetForm();
                    }

                    }.bind(this))
                    .catch(function (error) 
                    {                          
                        this.showoverlay = false;                        
                        console.log(error);
                    });


                    this.showoverlay = false; 
            },                               
        },
        created: function () { 
            this.get_migrated_fund();
        },
        computed: { }
        
    }
    
</script>